module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-331.c66c8ca.woff2";